import type { IBoxPlotSeriesTheme } from '../../../../series/box-plot/interface';

export const boxPlot: IBoxPlotSeriesTheme = {
  boxPlot: {
    style: {
      lineWidth: 1
    }
  },
  label: {
    style: {
      lineWidth: 2
    }
  }
};
